import { buildTextdomain } from 'react-gettext';
import Localization from '@dealersites/core/translations/Localization';

const i18n = (global.i18n = global.i18n || {});
const DS_INVENTORY_TEXT_DOMAIN = 'dealersite-inventory';

const translations = {
  en: buildTextdomain(require('./en.json')),
  fr: buildTextdomain(require('./fr.json')),
};

const inventoryLocalization = new Localization(translations, DS_INVENTORY_TEXT_DOMAIN);
i18n.inventory = inventoryLocalization;

export { inventoryLocalization, translations, DS_INVENTORY_TEXT_DOMAIN };
